export * from './search-dm-category.component';
export * from './search-dm-category.module';
